const handleAddClickListenersBySelector = (selector, callback) => {
	Array.prototype.map
			.call(
				document.querySelectorAll(selector),
				(element) => element.addEventListener('click', callback)
			);
}

const handleCallToActionClick = (data = {}) => {
	return new Promise((resolve) => {
		gtag('event', 'call_to_action_click', data);

		resolve();
	});
};

const prepareActionDataByElement = (element) => {
	const data = {};

	const dataLocation = element?.getAttribute('data-location');
	const dataUrl = element?.getAttribute('data-url');

	let dataText = element?.getAttribute('data-text') || element.innerHTML;

	if(dataText) {
		data.click_text = dataText.replace(/<[^>]+>/g, ' ')?.replace(/\s+/g, " ")?.trim();
	}

	if(dataLocation) {
		data.location = dataLocation;
	}

	if(dataUrl) {
		data.click_url = dataUrl;
	}

	return data;
}

handleAddClickListenersBySelector('a[href$="/login"]', () => gtag('event', 'login_click'));
handleAddClickListenersBySelector('a[href$="/plans"]', async (e) => {
	const { currentTarget } = e;

	await handleCallToActionClick({
		...prepareActionDataByElement(currentTarget),
		click_url: '/plans',
	});
});

handleAddClickListenersBySelector('[data-listener]', async (e) => {
	const { currentTarget } = e;

	await handleCallToActionClick(
		prepareActionDataByElement(currentTarget)
	);
});

const handleExperimentEvent = (exp_variant_string) => {
    gtag('event', 'experience_impression', {
        exp_variant_string,
    });
};

export { handleExperimentEvent };
